module.exports = __webpack_public_path__ + "img/HHS-NIH_NIAID_LogoSet_Web-Small_Black.0a2befaa.png";